import React, { useLayoutEffect, useState } from 'react';
// import Banner from './banner';
import Subtitle from './02_subtitle';
import QuestionAccordion from './03_accordion';
// import generic from "../../static/generic.json";
// import charger from "../../static/charger.json";
import faqs from '../../../static/cposFaqs.json';

export default function FAQ() {
  const [activeTab, setActiveTab] = useState('all');
  const [allQuestions, setAllQuestions] = useState(faqs);

  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);

  const handleTabSwitch = (next) => {
    if (next === 'all') {
      setActiveTab(next);
      setAllQuestions(faqs);
    } else {
      setActiveTab(next);
      const filtered = faqs.filter((question) => question.category === next);
      setAllQuestions(filtered);      
    }
  };

  const handleSearchQuery = () => {
    // setActiveTab(query);
  };

  // useLayoutEffect(() => {
  //   console.log(allQuestions);
  // }, [allQuestions]);

  return (
    <div className='blade-padding-sm'>
      {/* <Banner />*/}
      <Subtitle
        handleQuery={handleSearchQuery}
        activeTab={activeTab}
        switchTabs={handleTabSwitch}
      />
      <QuestionAccordion activeTab={activeTab} data={allQuestions} />
    </div>
  );
}
